import { Link } from '@/app/_components/common/Link';
import type { Review } from '@/app_data/mock/ndrData';
import { trackGtmEvent } from '@/app_lib/utils/ndrUtils';

interface NdrInContentBannerProps {
  review: Review;
  queryParams?: string;
}

export const NdrInContentBanner = ({ review, queryParams = '' }: NdrInContentBannerProps) => {
  return (
    <div className='flex max-lg:flex-col items-center px-6 lg:px-8 py-6 gap-8 lg:gap-10 rounded-sm border stroke-accent shadow-[0_4px_20px_rgba(0,0,0,0.16)] bg-blue-50 font-graphik-compact font-normal text-primary'>
      <div className='flex flex-col items-start gap-3 max-lg:self-stretch lg:flex-[1_0_0]'>
        <div className='typography-level-4 font-semibold'>{review.companyName}</div>
        <div className='typography-default'>What would you do if you were debt free?</div>
      </div>
      <div className='flex flex-col items-center gap-3 max-lg:w-full'>
        <Link
          className='flex justify-center items-center w-full px-8 py-4 gap-2 rounded-full bg-blue-600 text-white text-base font-medium leading-[16px]'
          href={`${review.ctas.sticky.url}?${queryParams}`}
          onClick={() => {
            trackGtmEvent(`${review.ctas.sticky.url}?${queryParams}`);
          }}
        >
          Get Your Free Estimate
        </Link>
        <div className='typography-sm'>On {review.companyName}'s Website</div>
      </div>
    </div>
  );
};
